module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "media-piece-edit-form"
    }
  }, [_c('h2', [_vm._v("Edit Piece")]), _vm._v(" "), _c('form', [(!_vm.savingForm) ? [(!_vm.deleteMode) ? [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Piece Title"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMediaData.usesUploadFile),
      expression: "selectedMediaData.usesUploadFile"
    }]
  }, [_vm._v("You cannot edit media or preview image. Instead, delete this piece and create a new one.")])]), _vm._v(" "), _c('label', [_c('markdown-editor', {
    attrs: {
      "placeholder": "Description (Optional)"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMediaData.usesExternalUrl),
      expression: "selectedMediaData.usesExternalUrl"
    }]
  }, [_vm._v("\n                        Media (External Url) "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mediaText),
      expression: "mediaText"
    }],
    attrs: {
      "type": "text",
      "name": "mediaPieceText",
      "placeholder": "http://..."
    },
    domProps: {
      "value": (_vm.mediaText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mediaText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMediaData.usesYoutubeLink),
      expression: "selectedMediaData.usesYoutubeLink"
    }]
  }, [_vm._v("\n                        Youtube Link "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mediaText),
      expression: "mediaText"
    }],
    attrs: {
      "type": "text",
      "name": "mediaPieceText",
      "placeholder": "http://..."
    },
    domProps: {
      "value": (_vm.mediaText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mediaText = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('fieldset', [_c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exitEditMode($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.enterDeleteMode($event)
      }
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitEditedPiece($event)
      }
    }
  }, [_vm._v("Save")])]), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('fieldset', [_c('ul', {
    staticClass: "validation-messages error"
  }, _vm._l((_vm.formErrors), function(formError) {
    return _c('li', [_vm._v(_vm._s(formError))])
  }))]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.deleteMode) ? [_c('fieldset', [_c('h1', [_vm._v("Are you sure you want to delete this piece?")]), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exitDeleteMode($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deletePiece($event)
      }
    }
  }, [_vm._v("Delete")])])] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.savingForm) ? [_c('saver-large')] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-84d4856e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Media/FormEditMediaPiece.vue
// module id = 898
// module chunks = 2